// Keep the whole native Shopify carousel in the selected media's proportions.
// Images remain uncropped; portrait clips occupy their full vertical frame.
function setupMarksverseProductGalleries(root = document) {
  root.querySelectorAll('.product-information__media > media-gallery.media-gallery--carousel').forEach((gallery) => {
    if (gallery.dataset.marksverseRatioObserver) return;
    const slides = gallery.querySelector('slideshow-slides');
    if (!slides) return;
    gallery.dataset.marksverseRatioObserver = 'true';
    const syncRatio = () => {
      const active = slides.querySelector('slideshow-slide[aria-hidden="false"]') || slides.querySelector('slideshow-slide');
      if (!active) return;
      const ratio = Number.parseFloat(active.querySelector('.product-media')?.style.getPropertyValue('--ratio'));
      if (Number.isFinite(ratio) && ratio > 0) gallery.style.setProperty('--gallery-aspect-ratio', String(ratio));
    };
    const observer = new MutationObserver(syncRatio);
    observer.observe(slides, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });
    syncRatio();
  });
}
setupMarksverseProductGalleries();
document.addEventListener('shopify:section:load', (event) => setupMarksverseProductGalleries(event.target));
// Native variant selection may replace the entire gallery, not just its slides.
new MutationObserver((changes) => {
  if (changes.some(({ addedNodes }) => [...addedNodes].some((node) =>
    node.matches?.('media-gallery.media-gallery--carousel') || node.querySelector?.('media-gallery.media-gallery--carousel')
  ))) setupMarksverseProductGalleries();
}).observe(document.body, { childList: true, subtree: true });
